@if (loaded()) {
  <div class="report-container">
    <hyperkit-typography variant="h5">Overview</hyperkit-typography>
    <hunt-details-editor
      title="Executive Summary"
      [value]="huntView.executiveSummary()"
      (valueChange)="huntEditor.updateExecutiveSummary($event)"
    ></hunt-details-editor>
    <hunt-details-editor
      title="Abstract"
      [value]="huntView.abstract()"
      (valueChange)="huntEditor.updateAbstract($event)"
    ></hunt-details-editor>
    <hunt-details-editor
      title="Hypothesis"
      [value]="huntView.hypothesis()"
      (valueChange)="huntEditor.updateHypothesis($event)"
    ></hunt-details-editor>
  </div>
} @else {
  <p>Loading…</p>
}
